// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"1f3a7c90","394":"7b5c3052","453":"d855a71b","546":"1f6cae0e","979":"289eb3ff"}[chunkId] + ".chunk.js";
};